enum Step {
  CART,
  DELIVERY,
  CONFIRMATION
}


abstract class Steps {
  public static getIcon(step: Step): string {
    switch (step) {
      case Step.CART:
        return 'shopping_cart';
      case Step.DELIVERY:
        return 'local_shipping';
      case Step.CONFIRMATION:
        return 'done';
      default:
        throw Error('unknown step');
    }
  }

  public static getName(step: Step): string {
    switch (step) {
      case Step.CART:
        return 'cartPage.header.steps.cart';
      case Step.DELIVERY:
        return 'cartPage.header.steps.delivery';
      case Step.CONFIRMATION:
        return 'cartPage.header.steps.confirmation';
      default:
        throw Error('unknown step');
    }
  }

  public static getButtonCaption(step: Step): string {
    switch (step) {
      case Step.CART:
        return 'cartPage.header.steps.buttonCaption.goToDeliveryDetails';
      case Step.DELIVERY:
        return 'cartPage.header.steps.buttonCaption.submitOrder';
      default:
        throw Error('unknown step');
    }
  }

  public static isFirst(step: Step): boolean {
    return step === Step.CART;
  }

  public static isLast(step: Step): boolean {
    return step === Step.CONFIRMATION;
  }
}

export { Step, Steps };
